/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { markAppUpdateAvailable } from './composables/useAppUpdate'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
      // Fase 4.1 do plano de otimização de login (docs/planos/PLANO-OTIMIZACAO-LOGIN.md):
      // skipWaiting+clientsClaim (vue.config.js) já fazem esse SW novo assumir
      // o controle sozinho — isso só marca que o bundle em memória desta aba
      // ficou desatualizado de verdade, pra quem depende disso (login) agir.
      markAppUpdateAvailable()
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
